<template>
  <div class='gift-bag-wrap'>
    <div class='title a-text-17 a-lightblack'>{{bagTitle}}<span class='a-text-13 a-gray' v-if='bagInfo.desc'>（{{bagInfo.desc}}）</span></div>
    <div class='bag-list'>
      <div class='bag-item fx-row fx-c-center' v-for="(item, index) in bagInfo.itemList" :key='index'>
        <div class='fx-1'>
          <div class='bag-name a-text-14 a-brown'>{{item.title}}</div>
          <div class='content-item a-brown-1 a-text-12' v-for="(desItem, idx) in item.itemList" :key='idx'>{{desItem.content}}</div>
          <div class='bag-notice a-brown-light' v-if='item.desc'>{{item.desc}}，每月最高返现5次</div>
        </div>
        <div class='a-brown-1 '>
          <div class='action-btn a-text-13 fx-center' v-if='!item.isBuy || item.type == 1' @click='handBuyGiftbag(item)'>
            {{item.btnText}}
          </div>
          <div class='fx-col fx-c-center' v-else>
            <img src='https://cdn.133.cn/gtgj/vipcard/isbuy.png' alt='' class='icon-isbuy' />
            <div class='a-text-12'>礼包已到账</div>
          </div>
        </div>
        <img src='https://cdn.133.cn/gtgj/vipcard/recommended.png' alt='' class='icon-tag' v-if='item.isHot'/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    level: {
      type: [String, Number],
      required: true
    },
    currentIndex: {
      type: [String, Number],
      required: true
    },
    bagInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    bagTitle() {
      const _allTitle = new Map([
        ['3', ['抢票礼包仅售49元', '买礼包送黄金会员']],
        ['4', ['白金常旅客礼包限量发售，首单立返20元', '买礼包送白金会员']],
        ['5', ['钻石常旅客礼包限量发售，首单立返50元', '买礼包送钻石会员']],
      ]);
      const _target = _allTitle.get(this.currentIndex);
      return  Number(this.level) > Number(this.currentIndex) ? _target[0] : _target[1];
      
    }
  },
  methods: {
    handBuyGiftbag( target ) {
      let _str = target.isBuy ? '去查看礼包' : '去收银台';
      // console.log(_str)
    }
  },
  
}
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

.gift-bag-wrap {
  background: #ffffff;
  margin-bottom: 8 * $px;
  padding: 0 14 * $px 20 * $px;
  @mixin setSize($iWidth, $iHeight) {
    width: $iWidth * $px;
    height: $iHeight * $px;
  }
  .icon-tag {
    @include setSize(48, 48);
    position: absolute;
    right: -6 * $px;
    top: -6 * $px;
  }
  .icon-isbuy {
    @include setSize(16, 16);
    display: block;
    margin-bottom: 5 * $px;
  }
  .a-brown {
    color: #C7773D;
  }
  .a-brown-1 {
    color: #BA792F;
  }
  .a-brown-light {
    color: #D6BC9F;
  }
  .title {
    line-height: 24 * $px;
    padding: 14 * $px 0;
  }
  .bag-item {
    width: 100%;
    box-sizing: border-box;
    position: relative;
    background: #FFFBF5 ;
    border-radius: 6 * $px;
    border: 4 * $px solid #FAE0B4;
    padding: 10 * $px;
    line-height: 1;
    margin-top: 14 * $px;
    &:first-of-type {
      margin-top: 0;
    }
    .bag-name {
      padding-bottom: 2 * $px;
    }
    .content-item {
      margin-top: 8 * $px;
      &:before {
        @include setSize(4, 4);
        display: inline-block;
        content: '';
        transform: rotate(-45deg);
        border-radius: 0.6 * $px;
        margin: 0 4 * $px 2 * $px 0;
        background: #BA792F;
      }
    }
    
    .bag-notice {
      font-size: 10 * $px;
      line-height: 14 * $px;
      margin-top: 8 * $px;
    }
    .action-btn {
      width: 26 * $px;
      height: 54 * $px;
      border-radius: 50%;
      background: #F7E1B2;
      padding: 0 14 * $px;
      line-height: 15 * $px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/projects/vipCard/pages/home/components/home-gift-bag.vue